(function() {
    'use strict';

    angular
        .module('MW.ContactManager.BeatService', [
            'Configuration',
            'MW.Framework.TranslationService',
            'MW.Framework.CoreUserService'
        ])
        .service('BeatService', [
            '$q',
            '$http',
            '$timeout',
            'CONTACT_MANAGER_BEATS_URL',
            'translationService',
            'CoreUserService',
            function($q, $http, $timeout, CONTACT_MANAGER_BEATS_URL, translationService, CoreUserService) {
                this.$timeout = $timeout;
                this.CoreUserService = CoreUserService;
                this.cachedContactBeats = [];
                this.cachedSourceBeats = [];
                this.orignalContactBeats = [];
                this.orignalSourceBeats = [];
                this.cachedUserLanguage = {
                    'contact': this.CoreUserService.getLanguage(),
                    'source': this.CoreUserService.getLanguage()
                };

                var translateBeats = function translateBeats(beatsArray) {
                    var returningBeats = angular.copy(beatsArray);
                    returningBeats.forEach(function translateParent(beat){
                        beat.name = translationService.getLocalizedString(beat.name);
                        if(beat.children && beat.children.length > 0){
                            beat.children.forEach(function translateChild(childBeat){
                                childBeat.name = translationService.getLocalizedString(childBeat.name);
                            }.bind(this));
                        }
                    }.bind(this));

                    return returningBeats;
                };

                this.getAllContactBeats = function getAllContactBeats() {
                    var deferred = $q.defer();
                    if(!this.cachedContactBeats.length) {
                        $http.get(CONTACT_MANAGER_BEATS_URL + '/contacts')
                            .then(function(response) {
                                this.orignalContactBeats = response.data;
                                this.cachedContactBeats = translateBeats(this.orignalContactBeats);
                                deferred.resolve(this.cachedContactBeats);
                            }.bind(this))
                            .catch(function(response) {
                                deferred.reject(response.data);
                            });
                    } else {
                        this.$timeout(function() {
                            if(this.CoreUserService.getLanguage() !== this.cachedUserLanguage.contact) {
                                this.cachedContactBeats =  translateBeats(this.orignalContactBeats);
                                this.cachedUserLanguage.contact = this.CoreUserService.getLanguage();
                            }
                            deferred.resolve(this.cachedContactBeats);
                        }.bind(this), 0, false);
                    }

                    return deferred.promise;
                };

                this.getAllSourceBeats = function getAllSourceBeats() {
                    var deferred = $q.defer();
                    if(this.cachedSourceBeats.length <= 0) {
                        $http.get(CONTACT_MANAGER_BEATS_URL + '/sources')
                            .then(function(response) {
                                this.orignalSourceBeats = response.data;
                                this.cachedSourceBeats = translateBeats(this.orignalSourceBeats);
                                deferred.resolve(this.cachedSourceBeats);
                            }.bind(this))
                            .catch(function(response) {
                                deferred.reject(response.data);
                            });
                    } else {
                        this.$timeout(function() {
                            if(this.CoreUserService.getLanguage() !== this.cachedUserLanguage.source) {
                                this.cachedSourceBeats = translateBeats(this.orignalSourceBeats);
                                this.cachedUserLanguage.source = this.CoreUserService.getLanguage();
                            }
                            deferred.resolve(this.cachedSourceBeats);
                        }.bind(this), 0, false);
                    }

                    return deferred.promise;
                };
            }
        ]);
}());
